export enum MISSING_MANIFEST_COLUMN_NAME {
  ID = "id",
  LOCATION_NAME = "locationName",
  TRACKING_NUMBER = "trackingNumber",
  ARRIVAL_DATE = "arrivalDate",
  NOTES = "notes",
  CREATED_ON = "createdOn",
  UPDATED_ON = "updatedOn",
}

export enum MISSING_MANIFEST_LABEL_NAME {
  ID = "ID",
  LOCATION_NAME = "Location Name",
  TRACKING_NUMBER = "Tracking Number",
  ARRIVAL_DATE = "Arrival Date",
  NOTES = "Notes",
  CREATED_ON = "Created On",
  UPDATED_ON = "Updated On",
}

export const MISSING_MANIFEST_FILTER_COLUMN_OPTIONS = [
  {
    label: MISSING_MANIFEST_LABEL_NAME.LOCATION_NAME,
    value: MISSING_MANIFEST_COLUMN_NAME.LOCATION_NAME,
  },
  {
    label: MISSING_MANIFEST_LABEL_NAME.ARRIVAL_DATE,
    value: MISSING_MANIFEST_COLUMN_NAME.ARRIVAL_DATE,
  },
];
